function getFieldStatus(validationMessages = []) {
  if (validationMessages.length) {
    if (validationMessages.some((msg) => msg.type === "invalid"))
      return "invalid";
    if (validationMessages.every((msg) => msg.type === "valid"))
      return "valid";
  }
}
export {
  getFieldStatus
};
//# sourceMappingURL=getFieldStatus.js.map
